import React from "react";
import img1 from "../assets/images/flat.jpg";
import { brandColor } from "../common/constant";
import CountUp from "react-countup"; // Import CountUp
import { useInView } from 'react-intersection-observer'; // Import the Intersection Observer

const TotalWorkBannner = () => {
  // Setting up useInView hook to track visibility
  const { ref, inView } = useInView({
    triggerOnce: true, // Trigger only once when the element first comes into view
    threshold: 0.5,     // Trigger when 50% of the element is visible
  });

  return (
    <div className="relative py-12">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${img1})`, 
          zIndex: -1,
          opacity: 0.9,
        }}
      ></div>

      {/* Content */}
      <div className="max-w-5xl mx-auto bg-white text-center py-6 px-6">
        <h2 style={{ color: brandColor }} className="text-2xl md:text-4xl font-bold text-gray-800 mb-6">
          With Placezio Estate, discover the perfect property that suits your needs
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {/* Stat 1 */}
          <div ref={ref} className="bg-white shadow-md rounded-lg p-6">
            <h3 className="text-xl font-bold text-[#54BD95]">OVER</h3>
            <p className="text-3xl font-bold text-[#54BD95] mt-2">
              {inView && <CountUp start={0} end={1000} duration={2.5} separator="," />}
              {/* CountUp will only start when the section is in view */}
              +
            </p>
            <p className="text-[#54BD95]">Happy Customers</p>
          </div>

          {/* Stat 2 */}
          <div ref={ref} className="bg-white shadow-md rounded-lg p-6">
            <h3 className="text-xl font-bold text-[#54BD95]">OVER</h3>
            <p className="text-3xl font-bold text-[#54BD95] mt-2">
              {inView && <CountUp start={0} end={10000} duration={3} separator="," />}
              {/* CountUp will only start when the section is in view */}
              +
            </p>
            <p className="text-[#54BD95]">Monthly Searches</p>
          </div>

          {/* Stat 3 */}
          <div ref={ref} className="bg-white shadow-md rounded-lg p-6">
            <h3 className="text-xl font-bold text-[#54BD95]">OVER</h3>
            <p className="text-3xl font-bold text-[#54BD95] mt-2">
              {inView && <CountUp start={0} end={40} duration={2.5} />}
              {/* CountUp will only start when the section is in view */}
              +
            </p>
            <p className="text-[#54BD95]">Agents</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TotalWorkBannner;
